import React, { Component } from 'react'
import Switch from "react-switch";
import axios from 'axios';
import Select from 'react-select';
import { ACCOUNT_CREATED } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';
import { Notifications } from '../common/notification';
import AccountBilling from './accountBilling';
import { ACCOUNT_FILE } from '../routers/RouteConstants';
import {  withRouter  } from 'react-router-dom'



export class AddAccountPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            switched: true,
            limitSwitch:true,
            accountName: '',
            rateUpdateEmail: '',
            accountEmail: '',
            location: '',
            maxRate: '',
            localANIASRBlockValue: '',
            localDNISASRBlockValue: '',
            session: '',
            cps: '',
            credit: '',
            selectType: '',
            profitMarkup: '35%',
            rateEmail:'',
            billingEmail:'',
            ban: '',
            msg: '',
            mediaBlock: false,
            suspend: false,
            typeOptions: [
                { value: 'postpaid', label: 'Postpaid' },
                { value: 'prepaid', label: 'Prepaid' }
            ],

            selectAccountLCRType: { value: 'system', label: 'True-LCR' },
            optionAccountLCRType: [
                { value: 'system', label: 'True-LCR' },
                { value: 'system-callhold', label: 'LCR Considering Carrier Holdtime' }
            ],

            selectAccountStatus: { value: 'Enabled', label: 'Enabled' },
            optionAccountStatus: [
                { value: 'Credit Hold', label: 'Credit Hold' },
                { value: 'Enabled', label: 'Enabled' },
                { value: 'Disabled', label: 'Disabled' }
            ],
            isLoad:false,
            cName: null,
            inboundCustomerId:0,
            stirLevel:{ value: '2', label: 'Block Unsigned' },
            optionStir: [
                { value: '1', label: 'No Treatment' },
                { value: '2', label: 'Block Unsigned' },
                { value: '3', label: 'Sign Unsigned Calls with Attestation A' },
                { value: '4', label: 'Sign Unsigned Calls with Attestation B' },
                { value: '5', label: 'Sign Unsigned Calls with Attestation C' },
            ],

            invoiceLevel:{ value: 'Weekly', label: 'Weekly' },
            optionInvoice: [
                { value: 'Weekly', label: 'Weekly' },
                { value: 'Semi-monthly', label: 'Semi-monthly' },
                { value: 'Monthly', label: 'Monthly' },
            ],

            tnsAsrValue:{ value: 'Off', label: 'Off' },
            optiontnsAsrValue: [
                { value: 'Off', label: 'Off' },
                { value: '-1', label: '-1' },
                { value: '-2', label: '-2' },
                { value: '-3', label: '-3' },
                { value: '-4', label: '-4' },
            ],

        }
        this.handleChange = this.handleChange.bind(this)
        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
        this.handleSelectType = this.handleSelectType.bind(this)
        this.toggleSwitchSuspend = this.toggleSwitchSuspend.bind(this)
        this.toggleLimitSwitch = this.toggleLimitSwitch.bind(this)
        this.handleSelectStatus = this.handleSelectStatus.bind(this)
        this.handleSelectAccountLCRType = this.handleSelectAccountLCRType.bind(this)
        this.handleSelectStir = this.handleSelectStir.bind(this)     
        this.handleSelecttnsAsrValue = this.handleSelecttnsAsrValue.bind(this) 
        this.handleSelectInvoice = this.handleSelectInvoice.bind(this);
        this.clearForm = this.clearForm.bind(this)
        this.onSubmitChange = this.onSubmitChange.bind(this)
    }

    toggleSwitch() {
        this.setState({ switched: !this.state.switched })
    }

    toggleLimitSwitch() {
        this.setState({ limitSwitch: !this.state.limitSwitch })
    }

    toggleSwitchSuspend() {
        this.setState({ suspend: !this.state.suspend })
    }

    handleSelectStir(stirLevel) {
        this.setState({ stirLevel})
    }

    handleSelectInvoice(invoiceLevel) {
        this.setState({ invoiceLevel})
    } 

    handleSelecttnsAsrValue(tnsAsrValue) {
        this.setState({tnsAsrValue})
    } 

    handleSelectAccountLCRType(selectAccountLCRType) {
        this.setState({ selectAccountLCRType });
        console.log(`Option selectedAccountLCRType:`, selectAccountLCRType);
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSelectType(selectType) {
        this.setState({ selectType });
        console.log(`selectType:`, selectType);
    };

    handleSelectStatus(selectAccountStatus) {
        this.setState({ selectAccountStatus });
        console.log(`selectAccountStatus:`, selectAccountStatus);
    };

    clearForm() {
        this.setState({
            switched: false,
            accountName: '',
            accountEmail: '',
            rateUpdateEmail: '',
            billingEmail: '',
            location: '',
            session: '',
            cps: '',
            credit: '',
            maxRate:'', 
            localANIASRBlockValue: '',
            localDNISASRBlockValue:'',
            minimumProfit: '',
            cName: null,
            profitMarkup: '35%',
            ban: '',
        })
    }

    onSubmitChange() {
        const { accountName, stirLevel, accountEmail, rateUpdateEmail, billingEmail, ban, location, session, minimumProfit, invoiceLevel, cps, switched, credit, suspend, limitSwitch,  selectAccountStatus, cName, profitMarkup, selectAccountLCRType, maxRate, localANIASRBlockValue,  localDNISASRBlockValue,  tnsAsrValue } = this.state
        const accountAdd = {
            "accountName": accountName,
            "accountEmail": accountEmail,
            "rateUpdateEmail": rateUpdateEmail,
            "billingEmail": billingEmail,
            "ban": ban,
            "location": location,
            "sessions": parseInt(session),
            "cps": parseInt(cps),
            "creditLimit": parseInt(credit),
            "accountType": "*postpaid",
            "accountLCRType": selectAccountLCRType.value,
            "maxRate": parseFloat(maxRate),
            "minimumProfit":parseFloat(minimumProfit) ,
            "suspend": suspend,
            "active": switched,
            'disableACTAfterLIM':limitSwitch,
            'status':selectAccountStatus.value,
            "stirShakenLevel":stirLevel.value,
            "mediaBlock": this.state.mediaBlock,
            "invoice":invoiceLevel.value,
            'profitMarkup':parseFloat(profitMarkup),
            "tnsANIBlockValue": parseInt(tnsAsrValue.value),
            "localANIASRBlockValue": parseFloat(localANIASRBlockValue),
            "localDNISASRBlockValue": parseFloat(localDNISASRBlockValue),
            "cname": cName && cName.trim() !== '' ? cName : null,
        };
        this.setState({isLoad:true})
        console.log(`accountAdd`, accountAdd)
        if (accountName == '' || accountEmail == '') {
            console.log('fill form');
            Notifications.notify("One of form field is empty", "Failed", "error")
            this.setState({isLoad:false})

        }
        else if (session == '' || cps == '') {
            console.log('fill session');
            Notifications.notify("One of form field is empty", "Failed", "error")
            this.setState({isLoad:false})


        }
        else {
            var headers = { 'Authorization': "Bearer " + this.state.User.token }
            axios.post(ACCOUNT_CREATED, accountAdd, { headers }).then(res => {
                if (res.status === 200) {
                    console.log("responseeee", res)
                    this.setState({
                        msg: res.data.message,
                        isLoad:false
                    })
                    Notifications.notify(this.state.msg, "Created", "success")
                    this.props.history.push(ACCOUNT_FILE)
                }
                else {
                    Notifications.notify("failed Account Created", "Failed", "error")
                    this.setState({isLoad:false})
                }
            }).catch(err => {
                const message = err.response.data.message || "Faild to create account" 

                Notifications.notify(message, "Failed", "error")
                this.setState({isLoad:false})
               
            })
            console.log('accounAdd :>> ', accountAdd);
        }

    }

    render() {
        const { accountName, accountEmail, minimumProfit,  location, session, cps, credit, profitMarkup, rateUpdateEmail, billingEmail, ban, inboundCustomerId, systemLCROptions, typeOptions, suspend,cName, maxRate, localANIASRBlockValue ,localDNISASRBlockValue } = this.state

        const sectionStyle = {
            fontSize: '13px',
            fontWeight: '600',
            color: '#0F172A',
            letterSpacing: '0.02em',
            paddingBottom: '8px',
            marginBottom: '16px',
            marginTop: '24px',
            borderBottom: '2px solid #E2E8F0',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
        };

        const labelStyle = {
            fontWeight: '500',
            fontSize: '13px',
            color: '#475569',
            marginBottom: '6px'
        };

        const checkboxWrapperStyle = {
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px 14px',
            background: '#F8FAFC',
            borderRadius: '10px',
            border: '1px solid #E2E8F0',
            cursor: 'pointer',
            marginTop: '8px'
        };

        return (
            <div style={{
                border: '1px solid #E2E8F0',
                borderRadius: '16px',
                background: '#FFFFFF',
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                padding: '28px',
                animation: 'fadeInUp 0.4s ease'
            }}>
                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#10B981',display:'inline-block'}}></span>
                    Account Information
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account Name</label>
                            <input type="text" className="form-control" name="accountName" value={accountName} onChange={this.handleChange} placeholder="Enter account name" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account Email</label>
                            <input type="email" className="form-control" name="accountEmail" value={accountEmail} onChange={this.handleChange} placeholder="Enter account email" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account Status</label>
                            <Select
                                value={this.state.selectAccountStatus}
                                onChange={this.handleSelectStatus}
                                options={this.state.optionAccountStatus}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Address</label>
                            <input type="text" className="form-control" name="location" value={location} onChange={this.handleChange} placeholder="Enter account address" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Cname</label>
                            <input type="text" className="form-control" name="cName" value={cName} onChange={this.handleChange} placeholder="Enter Cname" />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#3B82F6',display:'inline-block'}}></span>
                    Billing
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Billing Email (For Invoice)</label>
                            <input type="email" className="form-control" name="billingEmail" value={billingEmail} onChange={this.handleChange} placeholder="Billing Email" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Billing Account Number (BAN)</label>
                            <input type="text" className="form-control" name="ban" value={ban} onChange={this.handleChange} placeholder="Enter BAN" />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Rate Update Email</label>
                            <input type="email" className="form-control" name="rateUpdateEmail" value={rateUpdateEmail} onChange={this.handleChange} placeholder="i.e. rates@xyzcompany.com" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Credit Limit</label>
                            <input type="number" className="form-control" name="credit" value={credit} onChange={this.handleChange} placeholder="Enter credit limit" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Invoice Period</label>
                            <Select
                                value={this.state.invoiceLevel}
                                onChange={this.handleSelectInvoice}
                                options={this.state.optionInvoice}
                            />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#8B5CF6',display:'inline-block'}}></span>
                    Settings
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>CPS</label>
                            <input type="number" className="form-control" name="cps" value={cps} onChange={this.handleChange} placeholder="Enter cps" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Session</label>
                            <input type="number" className="form-control" name="session" value={session} onChange={this.handleChange} placeholder="Enter session" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Account LCR Type</label>
                            <Select
                                value={this.state.selectAccountLCRType}
                                onChange={this.handleSelectAccountLCRType}
                                options={this.state.optionAccountLCRType}
                            />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Stir Shaken Level</label>
                            <Select
                                value={this.state.stirLevel}
                                onChange={this.handleSelectStir}
                                options={this.state.optionStir}
                            />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#F59E0B',display:'inline-block'}}></span>
                    Monitoring
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Minimum Profit</label>
                            <input type="number" className="form-control" name="minimumProfit" value={minimumProfit} onChange={this.handleChange} placeholder="Enter Minimum Profit" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Max Rate</label>
                            <input type="number" className="form-control" name="maxRate" value={maxRate} onChange={this.handleChange} placeholder="Enter Max Rate" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Profit Markup</label>
                            <input type="number" className="form-control" name="profitMarkup" value={profitMarkup} onChange={this.handleChange} placeholder="Enter Profit Markup" required />
                        </div>
                    </div>
                </div>

                <div style={sectionStyle}>
                    <span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#EF4444',display:'inline-block'}}></span>
                    ANI ASR Settings
                </div>
                <div className='row'>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Local ASR Value</label>
                            <input type="number" className="form-control" name="localANIASRBlockValue" value={localANIASRBlockValue} onChange={this.handleChange} placeholder="Enter Local ASR Value" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>Local DNIS ASR Value</label>
                            <input type="number" className="form-control" name="localDNISASRBlockValue" value={localDNISASRBlockValue} onChange={this.handleChange} placeholder="Enter Local ASR Value" required />
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-group">
                            <label style={labelStyle}>TNS ASR Value</label>
                            <Select
                                value={this.state.tnsAsrValue}
                                onChange={this.handleSelecttnsAsrValue}
                                options={this.state.optiontnsAsrValue}
                            />
                        </div>
                    </div>
                </div>

                <div className="row" style={{marginTop: '8px'}}>
                    <div className="col-md-4">
                        <div style={checkboxWrapperStyle} onClick={this.toggleLimitSwitch}>
                            <input type="checkbox" onChange={this.toggleLimitSwitch} checked={this.state.limitSwitch} style={{width:'16px',height:'16px',accentColor:'#10B981',cursor:'pointer'}} />
                            <div>
                                <div style={{fontSize:'13px',fontWeight:'600',color:'#0F172A'}}>Enforce Credit Limit</div>
                                <div style={{fontSize:'12px',color:'#94A3B8',marginTop:'2px'}}>No calls upon credit limit</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div style={checkboxWrapperStyle} onClick={e => this.setState({ mediaBlock: !this.state.mediaBlock })}>
                            <input
                                type="checkbox"
                                checked={this.state.mediaBlock}
                                onChange={e => this.setState({ mediaBlock: e.target.checked })}
                                style={{width:'16px',height:'16px',accentColor:'#10B981',cursor:'pointer'}}
                            />
                            <div>
                                <div style={{fontSize:'13px',fontWeight:'600',color:'#0F172A'}}>FAS Media Block</div>
                                <div style={{fontSize:'12px',color:'#94A3B8',marginTop:'2px'}}>Activate FAS Carrier Media Filter</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{borderTop:'1px solid #E2E8F0',marginTop:'24px',paddingTop:'20px',display:'flex',justifyContent:'flex-end'}}>
                    <button
                        type="submit"
                        onClick={this.onSubmitChange}
                        disabled={this.state.isLoad}
                        style={{
                            background: this.state.isLoad ? '#94A3B8' : 'linear-gradient(135deg, #10B981, #059669)',
                            color: '#FFFFFF',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '10px 24px',
                            fontSize: '13px',
                            fontWeight: '600',
                            cursor: this.state.isLoad ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            boxShadow: this.state.isLoad ? 'none' : '0 4px 12px rgba(16, 185, 129, 0.3)',
                            transition: 'all 200ms ease'
                        }}
                    >
                        Create
                        <i className={this.state.isLoad ? "icon-spinner4 spinner" : 'icon-file-plus'} style={{fontSize:'14px'}}></i>
                    </button>
                </div>
            </div>
        )
    }
}

export default  withRouter(AddAccountPageComponent)
